// extracted by mini-css-extract-plugin
module.exports = {"textBlurb":"styles_textBlurb__1kToe","highlight":"styles_highlight__1AQ_6"};